// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._XNkc{text-align:center}.eSfW0{display:flex;flex-direction:row;align-items:center;gap:15px}.FmSpx{display:flex;flex-direction:row;align-items:center;gap:7px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"amountSelect": `_XNkc`,
	"rowAndIconContainer": `eSfW0`,
	"rowContent": `FmSpx`
};
export default ___CSS_LOADER_EXPORT___;
